<template>
    <div>
        <form @submit.prevent class="mt-4">
            <div class="row">
                <div class="col-sm-12  mt-4 mb-3">
                    <div class="text-xl text-grey-darkest mr-2 mb-2 mb-lg-0 block lg:inline w-full lg:w-auto">Company Information</div>
                </div>

                <div class="col-sm-6 mb-3">
                    <label class="text-grey-darkest text-sm" for="name">Company Name</label>
                    <input v-model="form.name" type="text" name="name" id="name"
                           class="rounded w-full p-2 text-grey-darkest text-sm focus:outline-none border-1">
                </div>

                <div class="col-sm-6 mb-3">
                    <label class="text-grey-darkest text-sm" for="address">Company Address</label>
                    <input v-model="form.address" type="text" size="50" name="address" id="address"
                           class="rounded w-full p-2 text-grey-darkest text-sm focus:outline-none border-1">
                </div>
            </div>

            <div class="row">
                <div class="col-sm-6 mb-3">
                    <label class="text-grey-darkest text-sm" for="city">City</label>
                    <input v-model="form.city" type="text" name="city" id="city"
                           class="rounded w-full p-2 text-grey-darkest text-sm focus:outline-none border-1">
                </div>

                <div class="col-sm-6 mb-3">
                    <label class="text-grey-darkest text-sm" for="state">State</label>
                    <input v-model="form.state" type="text" name="state" id="state" maxlength="2"
                           class="rounded w-full p-2 text-grey-darkest text-sm focus:outline-none border-1">
                </div>

            </div>

            <div class="row">
                <div class="col-sm-6 mb-3">
                    <label class="text-grey-darkest text-sm" for="zip">Zip Code</label>
                    <input v-model="form.zip" type="text" name="zip" id="zip"
                           class="rounded w-full p-2 text-grey-darkest text-sm focus:outline-none border-1">
                </div>

                <div class="col-sm-6 mb-3">
                    <label class="text-grey-darkest text-sm" for="company_phone">Company Phone</label>
                    <input v-model="form.phone" type="text" name="company_phone"
                           v-mask="['(###) ###-####', '(###) ###-#### ext. ####']" id="company_phone"
                           class="rounded w-full p-2 text-grey-darkest text-sm focus:outline-none border-1">
                </div>
            </div>

            <div class="row">
                <div class="col-sm-6 mb-3">
                    <label class="text-grey-darkest text-sm" for="company_fax">Company Fax</label>
                    <input v-model="form.fax" type="text" name="company_fax" id="company_fax"
                           v-mask="['(###) ###-####', '(###) ###-#### ext. ####']"
                           class="rounded w-full p-2 text-grey-darkest text-sm focus:outline-none border-1">
                </div>

                <div class="col-sm-6 mb-3">
                    <label class="text-grey-darkest text-sm" for="company_type">Company Type</label>
                    <select name="company_type" id="company_type" v-model="form.company_type_id"
                            class="appearance-none bg-white border-1 focus:outline-none p-2 rounded text-grey-darkest text-sm w-full">
                        <option selected></option>
                        <option v-for="item in companyTypes" :value="item.id">
                            {{ item.code }}
                        </option>
                    </select>
                </div>
            </div>

            <div class="row">
                <div class="col-sm-6 mb-3">
                    <label class="text-grey-darkest text-sm" for="company_status">Company Status</label>
                    <select name="company_status" id="company_status" v-model="form.company_status_id"
                            class="appearance-none bg-white border-1 focus:outline-none p-2 rounded text-grey-darkest text-sm w-full">
                        <option selected></option>
                        <option v-for="status in companyStatuses" :value="status.id">
                            {{ status.name }}
                        </option>
                    </select>
                </div>

                <div class="col-sm-6 mb-3">
                    <label class="text-grey-darkest text-sm">Created Date</label>
                    <div class="row">
                        <div class="col-6">
                            <datepicker v-model="form.created_date.start" format="MM/dd/yyyy"
                                        input-class="cursor-pointer rounded w-full p-2 text-grey-darkest text-sm focus:outline-none border-1 border-grey">
                            </datepicker>
                        </div>
                        <div class="col-6">
                            <datepicker v-model="form.created_date.end" format="MM/dd/yyyy"
                                        input-class="cursor-pointer rounded w-full p-2 text-grey-darkest text-sm focus:outline-none border-1 border-grey">
                            </datepicker>
                        </div>
                    </div>
                </div>
            </div>

            <div class="row">
                <div class="col-sm-6 mb-3">
                    <label class="text-grey-darkest text-sm">Last Update Date</label>
                    <div class="row">
                        <div class="col-6">
                            <datepicker v-model="form.updated_date.start" format="MM/dd/yyyy"
                                        input-class="cursor-pointer rounded w-full p-2 text-grey-darkest text-sm focus:outline-none border-1 border-grey">
                            </datepicker>
                        </div>
                        <div class="col-6">
                            <datepicker v-model="form.updated_date.end" format="MM/dd/yyyy"
                                        input-class="cursor-pointer rounded w-full p-2 text-grey-darkest text-sm focus:outline-none border-1 border-grey">
                            </datepicker>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Custom Fields-->
            <div class="row" v-if="companyCustomFields.length > 0">
                <div class="col-sm-6 mb-3" v-for="(field, index) in companyCustomFields">

                    <label class="text-grey-darkest text-sm">{{ field.label_value }}</label>

                    <div v-if="field.options.length === 0 && field.type !== 4">
                        <input type="text" class="p-2 bg-white border-1 focus:outline-none rounded text-grey-darkest text-sm w-full" v-model="form.custom_fields[field.id]">
                    </div>
                    <div v-if="field.options.length > 0">
                        <multiselect v-model="form.custom_fields[field.id]"
                                     :id="field.name + '-' + field.id"
                                     :placeholder="'Select ' + field.name"
                                     :options="field.options"
                                     :multiple="true"
                                     track-by="id"
                                     label="name"
                                     value="id"
                                     :taggable="true"
                                     :close-on-select="true">
                        </multiselect>
                    </div>
                </div>
            </div>
        </form>
    </div>
</template>
<script>

import Form from "../../utils/form";
import Datepicker from "vuejs-datepicker";
import Multiselect from "vue-multiselect";
import Mixin from "./mixin";

export default {
    name: 'list-company',
    props: ['listName', 'objectType', 'list'],
    components: {Datepicker, Multiselect},
    mixins: [Mixin],
    data () {
        return {
            form: new Form({
                id: null,
                list_name: this.listName,
                name: '',
                address: '',
                city: '',
                state: '',
                zip: '',
                phone: '',
                fax: '',
                company_type_id: 0,
                company_status_id: 0,
                created_date: {start: '', end: ''},
                updated_date: {start: '', end: ''},
                object_type: 'company',
                custom_fields: {}
            }),
            companyTypes: [],
            companyStatuses: [],
            companyCustomFields: {},
        }
    },
    created() {
        this.getCompanyTypes();
        this.getTeamCompanyStatuses();
        this.fetchCustomFields();
        this.initForm();
    },
    watch: {
        listName: function(newVal, oldVal) {
            this.form.list_name = newVal
        },
        objectType: function(newVal, oldVal) {
            this.form.object_type = newVal
        }
    },
    methods: {
        getCompanyTypes() {
            let self = this;
            axios.get(route('api.settings.codes.company-type.index') ).then(({data}) => {
                self.companyTypes = data;
                self.companyTypes.push({id: null, code: ""})
            });
        },
        getTeamCompanyStatuses() {
            let self = this;
            axios.get(route('api.company-status.index')).then(({data}) => {
                self.companyStatuses = data;
                self.companyStatuses.unshift({id:null, name:""});
            });
        },
        saved() {
           this.saveList(this.form)
        },
        fetchCustomFields() {
            let self = this;
            axios.get(route('api.company-custom-field.index')+ '?company=true').then(({data}) => {
                self.companyCustomFields = data.data;
            });
        },
        initForm() {
            if(!!this.list.filter){
                this.form = this.initListForm(this.list, this.listName );
            }
        },
        update() {
            this.updateList(this.form, this.list)
        }
    }
}
</script>
